// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hEuvM{padding:15px 0}.ThMNi{padding:0}.A4Cjh{overflow:initial}.s0euf{padding:0 0;display:grid;grid-template-columns:repeat(auto-fit, minmax(200px, 1fr));gap:16px}.s0euf .ht83V{border-radius:8px}.s0euf .ht83V .hAytG{display:flex;flex-direction:column;align-items:flex-start;text-align:start;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceTemplateSelector": `hEuvM`,
	"confirmationModal": `ThMNi`,
	"confirmationModalContent": `A4Cjh`,
	"cardButtonsContainer": `s0euf`,
	"cardButton": `ht83V`,
	"cardButtonContent": `hAytG`
};
export default ___CSS_LOADER_EXPORT___;
